import axios from 'axios';
import { config } from '../config';
import { authService } from './auth';

// Cliente axios compartilhado por api.js e userApi.js.
// O header Authorization é enviado cru (sem prefixo "Bearer"), exatamente
// como o autorizador Cognito do API Gateway em produção espera.
export const http = axios.create({
  baseURL: config.api.baseUrl
});

http.interceptors.request.use(async (requestConfig) => {
  const token = await authService.getIdToken();
  if (token) {
    requestConfig.headers.Authorization = token;
  }
  return requestConfig;
});
